import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Dashboard Service
 * Handles all dashboard-related API calls
 */
const dashboardService = {
  // Booking History
  getBookingHistory: async (status) => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.BOOKING_HISTORY, { status });
    return response.data;
  },

  getBookingStatusCounts: async () => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.BOOKING_STATUS_COUNTS, {});
    return response.data;
  },

  // Get one page of bookings for a service status. The server returns the full total in count.
  getDataByServiceStatus: async (serviceStatus, page = 1, limit = 20) => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.DATA_BY_SERVICE_STATUS, {
      serviceStatus: parseInt(serviceStatus, 10),
      page,
      limit,
    });
    return response.data;
  },

  // Earnings
  getTotalEarning: async () => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.TOTAL_EARNING, { status: 2 });
    return response.data;
  },

  // Vendor Details
  getAllLength: async () => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.ALL_LENGTH, { status: 2 });
    return response.data;
  },

  // Booking Details
  getBookingV1: async (bookingId) => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.BOOKING_V1, { bookingId });
    return response.data;
  },

  // Car Images
  getCarImage: async (bookingId) => {
    const response = await apiClient.post(API_ENDPOINTS.DASHBOARD.CAR_IMAGE, { bookingId });
    return response.data;
  },
};

export default dashboardService;

